export default (data = {}) => {
    return {
        // Campos principales
        PartyIdentification: '',
        PartyName: '',
        typeid: 'DNI',
        
        // Información de contacto
        client_email: '',
        client_phone: '',
        
        // Dirección
        AddressLine: '',
        CityName: '',
        
        // Clasificación
        tipo_cliente: 'identificado',
        es_generico: false,
        
        // Campos legacy mantenidos para compatibilidad
        AdditionalAccountID: null,
        Country_IdentificationCode: null,
        Department: null,
        PartyEmail: null,
        TaxLevelCode: null,
        TaxTypeCode: null,
        client_birthday: null,
        countryEntity: null,
        countrySubentity: null,
        puntosId: null,
        sex: null,
        
        // Timestamps
        created_at: null,
        updated_at: null,
        deleted_at: null,
        
        // Sobrescribir con datos proporcionados
        ...data
    }
}